<template>
  <div class="header">
    <!-- Unauthenticated -->
    <header-before-login v-if="!isAuthenticated" />

    <!-- Authenticated -->
    <template v-else>
      <header-after-login v-if="lbilHeader === 'Lymphomap'" />
      <lbil-header-after-login v-else-if="lbilHeader === 'LBIL'" />
    </template>
  </div>
</template>

<script>
import { bus } from '@/main';
import { mapGetters } from 'vuex';
import headerAfterLogin from '../lymphomap-header/index';
import headerBeforeLogin from '../headerBeforeLogin/index';
import lbilHeaderAfterLogin from '../lbil/lbil-header/lbilHeader.vue';

export default {
  name: 'AppHeader',
  components: {
    'header-before-login': headerBeforeLogin,
    'header-after-login': headerAfterLogin,
    'lbil-header-after-login': lbilHeaderAfterLogin
  },
  data() {
    return {
      lbilHeader: localStorage.getItem('platform') || ''
    };
  },
  computed: {
    ...mapGetters(['isAuthenticated'])
  },
  mounted() {
    this.handlePlatformChange = (data) => {
      console.log('Received platform change event:', data);
      this.lbilHeader = data;
      localStorage.setItem('platform', data);
    };

    bus.$on('headerPlatformBus', this.handlePlatformChange);
  },
  beforeDestroy() {
    // Prevent memory leaks by cleaning up the global event listener
    bus.$off('headerPlatformBus', this.handlePlatformChange);
  }
};
</script>

<style lang="scss" scoped>
.testimonials {
  .header_fix {
    background: #000;
  }
}
</style>